// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as AppRouteImport } from './routes/app'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as AuthSignUpRouteImport } from './routes/auth/sign-up'
import { Route as AuthSignOutRouteImport } from './routes/auth/sign-out'
import { Route as AuthSignInRouteImport } from './routes/auth/sign-in'
import { Route as AuthPasswordResetRouteImport } from './routes/auth/password-reset'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutTermsRouteImport } from './routes/_layout/terms'
import { Route as LayoutPrivacyRouteImport } from './routes/_layout/privacy'
import { Route as LayoutFreeAiAuditBookingRouteImport } from './routes/_layout/free-ai-audit-booking'
import { Route as LayoutFreeAiAuditRouteImport } from './routes/_layout/free-ai-audit'
import { Route as LayoutContactRouteImport } from './routes/_layout/contact'
import { Route as LayoutBuildDemoRouteImport } from './routes/_layout/build-demo'
import { Route as LayoutBookDemoRouteImport } from './routes/_layout/book-demo'
import { Route as LayoutAboutRouteImport } from './routes/_layout/about'
import { Route as LayoutProductsIndexRouteImport } from './routes/_layout/products/index'
import { Route as LayoutProductsWebsiteAgentRouteImport } from './routes/_layout/products/website-agent'
import { Route as LayoutProductsOpenclawCustomDevelopmentRouteImport } from './routes/_layout/products/openclaw-custom-development'
import { Route as LayoutProductsMcpRouteImport } from './routes/_layout/products/mcp'
import { Route as LayoutProductsLeadGenRouteImport } from './routes/_layout/products/lead-gen'
import { Route as LayoutProductsInternalAgentRouteImport } from './routes/_layout/products/internal-agent'
import { Route as LayoutProductsExtractionApiRouteImport } from './routes/_layout/products/extraction-api'
import { Route as LayoutProductsAutomationSupportRouteImport } from './routes/_layout/products/automation-support'
import { Route as LayoutProductsAutomationReviewRouteImport } from './routes/_layout/products/automation-review'
import { Route as LayoutProductsAgenticSystemDevelopmentRouteImport } from './routes/_layout/products/agentic-system-development'
import { Route as LayoutProductsAgentRouteImport } from './routes/_layout/products/agent'
import { Route as LayoutContactIndexRouteImport } from './routes/_layout/contact/index'
import { Route as LayoutContactAutomationReviewRouteImport } from './routes/_layout/contact/automation-review'
import { Route as LayoutProductsWebsiteAgentIndexRouteImport } from './routes/_layout/products/website-agent/index'
import { Route as LayoutProductsOpenclawCustomDevelopmentIndexRouteImport } from './routes/_layout/products/openclaw-custom-development/index'
import { Route as LayoutProductsMcpIndexRouteImport } from './routes/_layout/products/mcp/index'
import { Route as LayoutProductsLeadGenIndexRouteImport } from './routes/_layout/products/lead-gen/index'
import { Route as LayoutProductsLeadGenAdvisorsRouteImport } from './routes/_layout/products/lead-gen/advisors'
import { Route as LayoutProductsInternalAgentIndexRouteImport } from './routes/_layout/products/internal-agent/index'
import { Route as LayoutProductsExtractionApiIndexRouteImport } from './routes/_layout/products/extraction-api/index'
import { Route as LayoutProductsExtractionApiWalkthroughRouteImport } from './routes/_layout/products/extraction-api/walkthrough'
import { Route as LayoutProductsExtractionApiParseReceiptRouteImport } from './routes/_layout/products/extraction-api/parse-receipt'
import { Route as LayoutProductsExtractionApiExtractRouteImport } from './routes/_layout/products/extraction-api/extract'
import { Route as LayoutProductsExtractionApiDocsRouteImport } from './routes/_layout/products/extraction-api/docs'
import { Route as LayoutProductsExtractionApiDeskewRouteImport } from './routes/_layout/products/extraction-api/deskew'
import { Route as LayoutProductsAutomationSupportIndexRouteImport } from './routes/_layout/products/automation-support/index'
import { Route as LayoutProductsAutomationReviewIndexRouteImport } from './routes/_layout/products/automation-review/index'
import { Route as LayoutProductsAgenticSystemDevelopmentIndexRouteImport } from './routes/_layout/products/agentic-system-development/index'
import { Route as LayoutProductsAgentIndexRouteImport } from './routes/_layout/products/agent/index'
import { Route as LayoutProductsAgentHowItWorksRouteImport } from './routes/_layout/products/agent/how-it-works'
import { Route as LayoutProductsExtractionApiDocsIndexRouteImport } from './routes/_layout/products/extraction-api/docs/index'
import { Route as LayoutProductsExtractionApiDocsParseRouteImport } from './routes/_layout/products/extraction-api/docs/parse'
import { Route as LayoutProductsExtractionApiDocsDeskewRouteImport } from './routes/_layout/products/extraction-api/docs/deskew'
import { Route as LayoutProductsExtractionApiDocsBillingRouteImport } from './routes/_layout/products/extraction-api/docs/billing'
import { Route as LayoutProductsExtractionApiDocsAuthRouteImport } from './routes/_layout/products/extraction-api/docs/auth'
import { Route as LayoutProductsAgentDemosIndexRouteImport } from './routes/_layout/products/agent/demos/index'
import { Route as LayoutProductsAgentDemosSlugRouteImport } from './routes/_layout/products/agent/demos/$slug'

const AppIndexLazyRouteImport = createFileRoute('/app/')()
const AppExtractionApiLazyRouteImport = createFileRoute('/app/extraction-api')()
const AppAccountLazyRouteImport = createFileRoute('/app/account')()
const AppExtractionApiWalkthroughLazyRouteImport = createFileRoute('/app/extraction-api/walkthrough')()

const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/auth.lazy').then((d) => d.Route))
const AppRoute = AppRouteImport.update({
            id: '/app',path: '/app',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/app.lazy').then((d) => d.Route))
const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          }).lazy(() => import('./routes/_layout.lazy').then((d) => d.Route))
const AuthVerifyRoute = AuthVerifyRouteImport.update({
            id: '/verify',path: '/verify',getParentRoute: () => AuthRoute
          }).lazy(() => import('./routes/auth/verify.lazy').then((d) => d.Route))
const AuthSignUpRoute = AuthSignUpRouteImport.update({
            id: '/sign-up',path: '/sign-up',getParentRoute: () => AuthRoute
          }).lazy(() => import('./routes/auth/sign-up.lazy').then((d) => d.Route))
const AuthSignOutRoute = AuthSignOutRouteImport.update({
            id: '/sign-out',path: '/sign-out',getParentRoute: () => AuthRoute
          }).lazy(() => import('./routes/auth/sign-out.lazy').then((d) => d.Route))
const AuthSignInRoute = AuthSignInRouteImport.update({
            id: '/sign-in',path: '/sign-in',getParentRoute: () => AuthRoute
          }).lazy(() => import('./routes/auth/sign-in.lazy').then((d) => d.Route))
const AuthPasswordResetRoute = AuthPasswordResetRouteImport.update({
            id: '/password-reset',path: '/password-reset',getParentRoute: () => AuthRoute
          }).lazy(() => import('./routes/auth/password-reset.lazy').then((d) => d.Route))
const AppIndexLazyRoute = AppIndexLazyRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/app/index.lazy').then((d) => d.Route))
const AppExtractionApiLazyRoute = AppExtractionApiLazyRouteImport.update({
            id: '/extraction-api',path: '/extraction-api',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/app/extraction-api.lazy').then((d) => d.Route))
const AppAccountLazyRoute = AppAccountLazyRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => AppRoute
          }).lazy(() => import('./routes/app/account.lazy').then((d) => d.Route))
const LayoutIndexRoute = LayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/index.lazy').then((d) => d.Route))
const LayoutTermsRoute = LayoutTermsRouteImport.update({
            id: '/terms',path: '/terms',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/terms.lazy').then((d) => d.Route))
const LayoutPrivacyRoute = LayoutPrivacyRouteImport.update({
            id: '/privacy',path: '/privacy',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/privacy.lazy').then((d) => d.Route))
const LayoutFreeAiAuditBookingRoute = LayoutFreeAiAuditBookingRouteImport.update({
            id: '/free-ai-audit-booking',path: '/free-ai-audit-booking',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/free-ai-audit-booking.lazy').then((d) => d.Route))
const LayoutFreeAiAuditRoute = LayoutFreeAiAuditRouteImport.update({
            id: '/free-ai-audit',path: '/free-ai-audit',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/free-ai-audit.lazy').then((d) => d.Route))
const LayoutContactRoute = LayoutContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/contact.lazy').then((d) => d.Route))
const LayoutBuildDemoRoute = LayoutBuildDemoRouteImport.update({
            id: '/build-demo',path: '/build-demo',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/build-demo.lazy').then((d) => d.Route))
const LayoutBookDemoRoute = LayoutBookDemoRouteImport.update({
            id: '/book-demo',path: '/book-demo',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/book-demo.lazy').then((d) => d.Route))
const LayoutAboutRoute = LayoutAboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/about.lazy').then((d) => d.Route))
const AppExtractionApiWalkthroughLazyRoute = AppExtractionApiWalkthroughLazyRouteImport.update({
            id: '/walkthrough',path: '/walkthrough',getParentRoute: () => AppExtractionApiLazyRoute
          }).lazy(() => import('./routes/app/extraction-api/walkthrough.lazy').then((d) => d.Route))
const LayoutProductsIndexRoute = LayoutProductsIndexRouteImport.update({
            id: '/products/',path: '/products/',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/index.lazy').then((d) => d.Route))
const LayoutProductsWebsiteAgentRoute = LayoutProductsWebsiteAgentRouteImport.update({
            id: '/products/website-agent',path: '/products/website-agent',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/website-agent.lazy').then((d) => d.Route))
const LayoutProductsOpenclawCustomDevelopmentRoute = LayoutProductsOpenclawCustomDevelopmentRouteImport.update({
            id: '/products/openclaw-custom-development',path: '/products/openclaw-custom-development',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/openclaw-custom-development.lazy').then((d) => d.Route))
const LayoutProductsMcpRoute = LayoutProductsMcpRouteImport.update({
            id: '/products/mcp',path: '/products/mcp',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/mcp.lazy').then((d) => d.Route))
const LayoutProductsLeadGenRoute = LayoutProductsLeadGenRouteImport.update({
            id: '/products/lead-gen',path: '/products/lead-gen',getParentRoute: () => LayoutRoute
          })
const LayoutProductsInternalAgentRoute = LayoutProductsInternalAgentRouteImport.update({
            id: '/products/internal-agent',path: '/products/internal-agent',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/internal-agent.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiRoute = LayoutProductsExtractionApiRouteImport.update({
            id: '/products/extraction-api',path: '/products/extraction-api',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api.lazy').then((d) => d.Route))
const LayoutProductsAutomationSupportRoute = LayoutProductsAutomationSupportRouteImport.update({
            id: '/products/automation-support',path: '/products/automation-support',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/automation-support.lazy').then((d) => d.Route))
const LayoutProductsAutomationReviewRoute = LayoutProductsAutomationReviewRouteImport.update({
            id: '/products/automation-review',path: '/products/automation-review',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/automation-review.lazy').then((d) => d.Route))
const LayoutProductsAgenticSystemDevelopmentRoute = LayoutProductsAgenticSystemDevelopmentRouteImport.update({
            id: '/products/agentic-system-development',path: '/products/agentic-system-development',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/agentic-system-development.lazy').then((d) => d.Route))
const LayoutProductsAgentRoute = LayoutProductsAgentRouteImport.update({
            id: '/products/agent',path: '/products/agent',getParentRoute: () => LayoutRoute
          }).lazy(() => import('./routes/_layout/products/agent.lazy').then((d) => d.Route))
const LayoutContactIndexRoute = LayoutContactIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutContactRoute
          }).lazy(() => import('./routes/_layout/contact/index.lazy').then((d) => d.Route))
const LayoutContactAutomationReviewRoute = LayoutContactAutomationReviewRouteImport.update({
            id: '/automation-review',path: '/automation-review',getParentRoute: () => LayoutContactRoute
          }).lazy(() => import('./routes/_layout/contact/automation-review.lazy').then((d) => d.Route))
const LayoutProductsWebsiteAgentIndexRoute = LayoutProductsWebsiteAgentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsWebsiteAgentRoute
          }).lazy(() => import('./routes/_layout/products/website-agent/index.lazy').then((d) => d.Route))
const LayoutProductsOpenclawCustomDevelopmentIndexRoute = LayoutProductsOpenclawCustomDevelopmentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsOpenclawCustomDevelopmentRoute
          }).lazy(() => import('./routes/_layout/products/openclaw-custom-development/index.lazy').then((d) => d.Route))
const LayoutProductsMcpIndexRoute = LayoutProductsMcpIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsMcpRoute
          }).lazy(() => import('./routes/_layout/products/mcp/index.lazy').then((d) => d.Route))
const LayoutProductsLeadGenIndexRoute = LayoutProductsLeadGenIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsLeadGenRoute
          }).lazy(() => import('./routes/_layout/products/lead-gen/index.lazy').then((d) => d.Route))
const LayoutProductsLeadGenAdvisorsRoute = LayoutProductsLeadGenAdvisorsRouteImport.update({
            id: '/advisors',path: '/advisors',getParentRoute: () => LayoutProductsLeadGenRoute
          }).lazy(() => import('./routes/_layout/products/lead-gen/advisors.lazy').then((d) => d.Route))
const LayoutProductsInternalAgentIndexRoute = LayoutProductsInternalAgentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsInternalAgentRoute
          }).lazy(() => import('./routes/_layout/products/internal-agent/index.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiIndexRoute = LayoutProductsExtractionApiIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsExtractionApiRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/index.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiWalkthroughRoute = LayoutProductsExtractionApiWalkthroughRouteImport.update({
            id: '/walkthrough',path: '/walkthrough',getParentRoute: () => LayoutProductsExtractionApiRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/walkthrough.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiParseReceiptRoute = LayoutProductsExtractionApiParseReceiptRouteImport.update({
            id: '/parse-receipt',path: '/parse-receipt',getParentRoute: () => LayoutProductsExtractionApiRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/parse-receipt.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiExtractRoute = LayoutProductsExtractionApiExtractRouteImport.update({
            id: '/extract',path: '/extract',getParentRoute: () => LayoutProductsExtractionApiRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/extract.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiDocsRoute = LayoutProductsExtractionApiDocsRouteImport.update({
            id: '/docs',path: '/docs',getParentRoute: () => LayoutProductsExtractionApiRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/docs.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiDeskewRoute = LayoutProductsExtractionApiDeskewRouteImport.update({
            id: '/deskew',path: '/deskew',getParentRoute: () => LayoutProductsExtractionApiRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/deskew.lazy').then((d) => d.Route))
const LayoutProductsAutomationSupportIndexRoute = LayoutProductsAutomationSupportIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsAutomationSupportRoute
          }).lazy(() => import('./routes/_layout/products/automation-support/index.lazy').then((d) => d.Route))
const LayoutProductsAutomationReviewIndexRoute = LayoutProductsAutomationReviewIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsAutomationReviewRoute
          }).lazy(() => import('./routes/_layout/products/automation-review/index.lazy').then((d) => d.Route))
const LayoutProductsAgenticSystemDevelopmentIndexRoute = LayoutProductsAgenticSystemDevelopmentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsAgenticSystemDevelopmentRoute
          }).lazy(() => import('./routes/_layout/products/agentic-system-development/index.lazy').then((d) => d.Route))
const LayoutProductsAgentIndexRoute = LayoutProductsAgentIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsAgentRoute
          }).lazy(() => import('./routes/_layout/products/agent/index.lazy').then((d) => d.Route))
const LayoutProductsAgentHowItWorksRoute = LayoutProductsAgentHowItWorksRouteImport.update({
            id: '/how-it-works',path: '/how-it-works',getParentRoute: () => LayoutProductsAgentRoute
          }).lazy(() => import('./routes/_layout/products/agent/how-it-works.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiDocsIndexRoute = LayoutProductsExtractionApiDocsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutProductsExtractionApiDocsRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/docs/index.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiDocsParseRoute = LayoutProductsExtractionApiDocsParseRouteImport.update({
            id: '/parse',path: '/parse',getParentRoute: () => LayoutProductsExtractionApiDocsRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/docs/parse.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiDocsDeskewRoute = LayoutProductsExtractionApiDocsDeskewRouteImport.update({
            id: '/deskew',path: '/deskew',getParentRoute: () => LayoutProductsExtractionApiDocsRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/docs/deskew.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiDocsBillingRoute = LayoutProductsExtractionApiDocsBillingRouteImport.update({
            id: '/billing',path: '/billing',getParentRoute: () => LayoutProductsExtractionApiDocsRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/docs/billing.lazy').then((d) => d.Route))
const LayoutProductsExtractionApiDocsAuthRoute = LayoutProductsExtractionApiDocsAuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => LayoutProductsExtractionApiDocsRoute
          }).lazy(() => import('./routes/_layout/products/extraction-api/docs/auth.lazy').then((d) => d.Route))
const LayoutProductsAgentDemosIndexRoute = LayoutProductsAgentDemosIndexRouteImport.update({
            id: '/demos/',path: '/demos/',getParentRoute: () => LayoutProductsAgentRoute
          })
const LayoutProductsAgentDemosSlugRoute = LayoutProductsAgentDemosSlugRouteImport.update({
            id: '/demos/$slug',path: '/demos/$slug',getParentRoute: () => LayoutProductsAgentRoute
          }).lazy(() => import('./routes/_layout/products/agent/demos/$slug.lazy').then((d) => d.Route))





const LayoutContactRouteChildren = {
  LayoutContactAutomationReviewRoute: LayoutContactAutomationReviewRoute,LayoutContactIndexRoute: LayoutContactIndexRoute
}

const LayoutContactRouteWithChildren = LayoutContactRoute._addFileChildren(LayoutContactRouteChildren)




const LayoutProductsAgentRouteChildren = {
  LayoutProductsAgentHowItWorksRoute: LayoutProductsAgentHowItWorksRoute,LayoutProductsAgentIndexRoute: LayoutProductsAgentIndexRoute,LayoutProductsAgentDemosSlugRoute: LayoutProductsAgentDemosSlugRoute,LayoutProductsAgentDemosIndexRoute: LayoutProductsAgentDemosIndexRoute
}

const LayoutProductsAgentRouteWithChildren = LayoutProductsAgentRoute._addFileChildren(LayoutProductsAgentRouteChildren)




const LayoutProductsAgenticSystemDevelopmentRouteChildren = {
  LayoutProductsAgenticSystemDevelopmentIndexRoute: LayoutProductsAgenticSystemDevelopmentIndexRoute
}

const LayoutProductsAgenticSystemDevelopmentRouteWithChildren = LayoutProductsAgenticSystemDevelopmentRoute._addFileChildren(LayoutProductsAgenticSystemDevelopmentRouteChildren)




const LayoutProductsAutomationReviewRouteChildren = {
  LayoutProductsAutomationReviewIndexRoute: LayoutProductsAutomationReviewIndexRoute
}

const LayoutProductsAutomationReviewRouteWithChildren = LayoutProductsAutomationReviewRoute._addFileChildren(LayoutProductsAutomationReviewRouteChildren)




const LayoutProductsAutomationSupportRouteChildren = {
  LayoutProductsAutomationSupportIndexRoute: LayoutProductsAutomationSupportIndexRoute
}

const LayoutProductsAutomationSupportRouteWithChildren = LayoutProductsAutomationSupportRoute._addFileChildren(LayoutProductsAutomationSupportRouteChildren)




const LayoutProductsExtractionApiDocsRouteChildren = {
  LayoutProductsExtractionApiDocsAuthRoute: LayoutProductsExtractionApiDocsAuthRoute,LayoutProductsExtractionApiDocsBillingRoute: LayoutProductsExtractionApiDocsBillingRoute,LayoutProductsExtractionApiDocsDeskewRoute: LayoutProductsExtractionApiDocsDeskewRoute,LayoutProductsExtractionApiDocsParseRoute: LayoutProductsExtractionApiDocsParseRoute,LayoutProductsExtractionApiDocsIndexRoute: LayoutProductsExtractionApiDocsIndexRoute
}

const LayoutProductsExtractionApiDocsRouteWithChildren = LayoutProductsExtractionApiDocsRoute._addFileChildren(LayoutProductsExtractionApiDocsRouteChildren)



const LayoutProductsExtractionApiRouteChildren = {
  LayoutProductsExtractionApiDeskewRoute: LayoutProductsExtractionApiDeskewRoute,LayoutProductsExtractionApiDocsRoute: LayoutProductsExtractionApiDocsRouteWithChildren,LayoutProductsExtractionApiExtractRoute: LayoutProductsExtractionApiExtractRoute,LayoutProductsExtractionApiParseReceiptRoute: LayoutProductsExtractionApiParseReceiptRoute,LayoutProductsExtractionApiWalkthroughRoute: LayoutProductsExtractionApiWalkthroughRoute,LayoutProductsExtractionApiIndexRoute: LayoutProductsExtractionApiIndexRoute
}

const LayoutProductsExtractionApiRouteWithChildren = LayoutProductsExtractionApiRoute._addFileChildren(LayoutProductsExtractionApiRouteChildren)




const LayoutProductsInternalAgentRouteChildren = {
  LayoutProductsInternalAgentIndexRoute: LayoutProductsInternalAgentIndexRoute
}

const LayoutProductsInternalAgentRouteWithChildren = LayoutProductsInternalAgentRoute._addFileChildren(LayoutProductsInternalAgentRouteChildren)




const LayoutProductsLeadGenRouteChildren = {
  LayoutProductsLeadGenAdvisorsRoute: LayoutProductsLeadGenAdvisorsRoute,LayoutProductsLeadGenIndexRoute: LayoutProductsLeadGenIndexRoute
}

const LayoutProductsLeadGenRouteWithChildren = LayoutProductsLeadGenRoute._addFileChildren(LayoutProductsLeadGenRouteChildren)




const LayoutProductsMcpRouteChildren = {
  LayoutProductsMcpIndexRoute: LayoutProductsMcpIndexRoute
}

const LayoutProductsMcpRouteWithChildren = LayoutProductsMcpRoute._addFileChildren(LayoutProductsMcpRouteChildren)




const LayoutProductsOpenclawCustomDevelopmentRouteChildren = {
  LayoutProductsOpenclawCustomDevelopmentIndexRoute: LayoutProductsOpenclawCustomDevelopmentIndexRoute
}

const LayoutProductsOpenclawCustomDevelopmentRouteWithChildren = LayoutProductsOpenclawCustomDevelopmentRoute._addFileChildren(LayoutProductsOpenclawCustomDevelopmentRouteChildren)




const LayoutProductsWebsiteAgentRouteChildren = {
  LayoutProductsWebsiteAgentIndexRoute: LayoutProductsWebsiteAgentIndexRoute
}

const LayoutProductsWebsiteAgentRouteWithChildren = LayoutProductsWebsiteAgentRoute._addFileChildren(LayoutProductsWebsiteAgentRouteChildren)



const LayoutRouteChildren = {
  LayoutAboutRoute: LayoutAboutRoute,LayoutBookDemoRoute: LayoutBookDemoRoute,LayoutBuildDemoRoute: LayoutBuildDemoRoute,LayoutContactRoute: LayoutContactRouteWithChildren,LayoutFreeAiAuditRoute: LayoutFreeAiAuditRoute,LayoutFreeAiAuditBookingRoute: LayoutFreeAiAuditBookingRoute,LayoutPrivacyRoute: LayoutPrivacyRoute,LayoutTermsRoute: LayoutTermsRoute,LayoutIndexRoute: LayoutIndexRoute,LayoutProductsAgentRoute: LayoutProductsAgentRouteWithChildren,LayoutProductsAgenticSystemDevelopmentRoute: LayoutProductsAgenticSystemDevelopmentRouteWithChildren,LayoutProductsAutomationReviewRoute: LayoutProductsAutomationReviewRouteWithChildren,LayoutProductsAutomationSupportRoute: LayoutProductsAutomationSupportRouteWithChildren,LayoutProductsExtractionApiRoute: LayoutProductsExtractionApiRouteWithChildren,LayoutProductsInternalAgentRoute: LayoutProductsInternalAgentRouteWithChildren,LayoutProductsLeadGenRoute: LayoutProductsLeadGenRouteWithChildren,LayoutProductsMcpRoute: LayoutProductsMcpRouteWithChildren,LayoutProductsOpenclawCustomDevelopmentRoute: LayoutProductsOpenclawCustomDevelopmentRouteWithChildren,LayoutProductsWebsiteAgentRoute: LayoutProductsWebsiteAgentRouteWithChildren,LayoutProductsIndexRoute: LayoutProductsIndexRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)




const AppExtractionApiLazyRouteChildren = {
  AppExtractionApiWalkthroughLazyRoute: AppExtractionApiWalkthroughLazyRoute
}

const AppExtractionApiLazyRouteWithChildren = AppExtractionApiLazyRoute._addFileChildren(AppExtractionApiLazyRouteChildren)



const AppRouteChildren = {
  AppAccountLazyRoute: AppAccountLazyRoute,AppExtractionApiLazyRoute: AppExtractionApiLazyRouteWithChildren,AppIndexLazyRoute: AppIndexLazyRoute
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)




const AuthRouteChildren = {
  AuthPasswordResetRoute: AuthPasswordResetRoute,AuthSignInRoute: AuthSignInRoute,AuthSignOutRoute: AuthSignOutRoute,AuthSignUpRoute: AuthSignUpRoute,AuthVerifyRoute: AuthVerifyRoute
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,AppRoute: AppRouteWithChildren,AuthRoute: AuthRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)